import { useEffect } from 'react';
import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react';
import { disableAllTracking } from 'src/analytics';
// components
import { MaintenanceScreen } from './components';

type Props = {
  component?: React.ReactNode;
};

const MainControlScreen = ({ component }: Props): JSX.Element => {
  const activeMaintenance = useFeatureIsOn('fwm-maintenance-sw');
  const disabledProjects = useFeatureValue('glb-mixpanel-disable', '');

  useEffect(() => {
    if (disabledProjects.split(',').includes('sales-web')) {
      disableAllTracking();
    }
  }, [disabledProjects]);

  return activeMaintenance ? (
    <MaintenanceScreen data-testid="maintenance-screen" />
  ) : (
    <>{component}</>
  );
};

export default MainControlScreen;
